// src/api/workoutApi.js

export const BASE_URL =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_BASE_URL) ||
  (typeof process !== "undefined" && process.env?.REACT_APP_API_BASE_URL) ||
  "https://prod.getrevibe.app/api";

// Re-export media utils so existing imports from workoutApi still work
export {
  MEDIA_BASE_URL,
  getFullUrl,
  getBestMedia,
} from "../Utils/Workout/mediaUtils";

/**
 * Generic fetch helper that reads the body as text first,
 * so we can surface a helpful error if the server returns HTML.
 */
const fetchJSON = async (url) => {
  const res = await fetch(url);
  const text = await res.text();

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error(
      `API error (HTTP ${res.status}): Expected JSON but got non-JSON response from ${url}. Check BASE_URL and server logs.`,
    );
  }

  if (!res.ok) {
    throw new Error(
      `API error (HTTP ${res.status}): ${data?.message || "Unknown error"} — ${url}`,
    );
  }

  return data;
};

/**
 * Fetch categories with pagination
 * Returns an object with categories array and pagination info
 */
export const fetchCategoriesPaginated = async ({
  page = 1,
  limit = 10,
  search = "",
}) => {
  const data = await fetchJSON(
    `${BASE_URL}/categories?sortOrder=asc&page=${page}&limit=${limit}&search=${search}`,
  );

  if (!data.categories) {
    throw new Error("Unexpected API response shape: missing `categories` key.");
  }

  return {
    categories: data.categories,
    pagination: {
      page: data.page || page,
      limit: data.limit || limit,
      total: data.total || 0,
      totalPages: data.totalPages || 0,
      hasNextPage: data.hasNextPage || data.page < data.totalPages,
    },
  };
};

/**
 * Fetch workouts with pagination
 * Returns an object with workouts array and pagination info
 */
export const fetchWorkoutsPaginated = async ({
  page = 1,
  limit = 10,
  search = "",
}) => {
  const data = await fetchJSON(
    `${BASE_URL}/workouts?sortOrder=asc&page=${page}&limit=${limit}&search=${search}`,
  );

  if (!data.workouts) {
    throw new Error("Unexpected API response shape: missing `workouts` key.");
  }

  return {
    workouts: data.workouts,
    pagination: {
      page: data.page || page,
      limit: data.limit || limit,
      total: data.total || 0,
      totalPages: data.totalPages || 0,
      hasNextPage: data.hasNextPage || data.page < data.totalPages,
    },
  };
};
